const headerData = [
  {
    prop: "id",
    label: "序号",
    columnwidth: 50,
  },
  {
    prop: "StatusName",
    label: "状态",
    columnwidth: 80,
  },
  {
    prop: "cCode",
    label: "出库单号",
    columnwidth: 130,
  },
  {
    prop: "dDate",
    label: "出库日期",
    columnwidth: 120,
  },
  {
    prop: "RDMonth",
    label: "出库年月",
    columnwidth: 100,
  },
  {
    prop: "dmodifysystime",
    label: "记录更新日期",
    columnwidth: 110,
  },
  {
    prop: "AccId",
    label: "分销商代码",
    columnwidth: 100,
  },
  {
    prop: "AccName",
    label: "分销商名称",
    columnwidth: 100,
  },
  {
    prop: "CusGrade",
    label: "卖方级别",
    columnwidth: 100,
  },
  {
    prop: "cCusName",
    label: "客户名称",
    columnwidth: 130,
  },
  {
    prop: "cCusCode",
    label: "客户编号",
    columnwidth: 130,
  },
  {
    prop: "CusType",
    label: "客户分类",
    columnwidth: 130,
  },
  {
    prop: "VoucherType",
    label: "单据类型",
    columnwidth: 130,
  },
  {
    prop: "cMaker",
    label: "制单人",
    columnwidth: 130,
  },
  {
    prop: "cInvStd",
    label: "产品代码",
    columnwidth: 130,
  },
  {
    prop: "cInvName",
    label: "产品名称",
    columnwidth: 130,
  },
  {
    prop: "cBatch",
    label: "批号",
    columnwidth: 130,
  },
  {
    prop: "ValiDate",
    label: "有效期至",
    columnwidth: 130,
  },
  {
    prop: "cInvCName",
    label: "产品线",
    columnwidth: 130,
  },
  {
    prop: "LEVEL1",
    label: "LEVEL1",
    columnwidth: 100,
  },
  {
    prop: "LEVEL2",
    label: "LEVEL2",
    columnwidth: 100,
  },
  {
    prop: "LEVEL3",
    label: "LEVEL3",
    columnwidth: 100,
  },
  {
    prop: "LEVEL4",
    label: "LEVEL4",
    columnwidth: 100,
  },
  {
    prop: "cComUnitName",
    label: "单位",
    columnwidth: 80,
  },
  {
    prop: "iQuantity",
    label: "出库数量",
    columnwidth: 80,
  },
  {
    prop: "iTaxUnitPrice",
    label: "原币含税单价",
    columnwidth: 100,
  },
  {
    prop: "iSum",
    label: "原币价税合计",
    columnwidth: 100,
  },
  {
    prop: "StandardCost",
    label: "参考价格",
    columnwidth: 80,
  },
  {
    prop: "StandardSum",
    label: "参考价格合计",
    columnwidth: 100,
  },
  {
    prop: "dDLDate",
    label: "发货日期",
    columnwidth: 100,
  },
  {
    prop: "cMemo",
    label: "表头备注",
    columnwidth: 130,
  },
  {
    prop: "cDLCode",
    label: "发货单号",
    columnwidth: 130,
  },
  {
    prop: "cVerifier",
    label: "审核人",
    columnwidth: 130,
  },
  {
    prop: "dcreatesystime",
    label: "创建时间",
    columnwidth: 130,
  },
  {
    prop: "dverifydate",
    label: "审核时间",
    columnwidth: 130,
  },
  {
    prop: "cInvCode",
    label: "产品编码",
    columnwidth: 130,
  },
  {
    prop: "iUnitPrice",
    label: "原币无税单价",
    columnwidth: 130,
  },
  {
    prop: "iTax",
    label: "原币税额",
    columnwidth: 130,
  },
  {
    prop: "iMoney",
    label: "原币金额",
    columnwidth: 130,
  },
  {
    prop: "iNatUnitPrice",
    label: "本币无税单价",
    columnwidth: 130,
  },
  {
    prop: "iNatMoney",
    label: "本币金额",
    columnwidth: 130,
  },
  {
    prop: "iNatSum",
    label: "本币价税合计",
    columnwidth: 130,
  },
  {
    prop: "iNatTax",
    label: "本币税额",
    columnwidth: 130,
  },
  {
    prop: "fOutQuantity",
    label: "发货数量",
    columnwidth: 80,
  },
  {
    prop: "iSettleQuantity",
    label: "开票数量",
    columnwidth: 80,
  },
  {
    prop: "iRetQuantity",
    label: "退货数量",
    columnwidth: 80,
  },
  {
    prop: "fretqtywkp",
    label: "退货未开票数量",
    columnwidth: 100,
  },
  {
    prop: "fretqtyykp",
    label: "退货已开票数量",
    columnwidth: 100,
  },
  {
    prop: "cexch_name",
    label: "币种",
    columnwidth: 80,
  },
  {
    prop: "iExchRate",
    label: "汇率",
    columnwidth: 80,
  },
  {
    prop: "iTaxRate",
    label: "税率",
    columnwidth: 80,
  },
];
export default headerData
